import React from 'react';
import styled from 'styled-components';
import Icon from '../Icon';

const PaginationContainer = styled.div`
  display: flex;
  flex-direction: row;

  .arrowContainer {
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .arrowLeft {
    margin-right: 20px;
    background-color: ${(props) =>
      props.disableLeft
        ? 'rgba(31, 43, 55, 0.04)'
        : props.theme.colors['terra-cotta']};
    color: ${(props) =>
      props.disableLeft ? props.theme.colors['dark'] : 'white'};
    &:hover {
      cursor: ${(props) => (props.disableLeft ? 'default' : 'pointer')};
    }
  }

  .arrowRight {
    background-color: ${(props) =>
      props.disableRight
        ? 'rgba(31, 43, 55, 0.04)'
        : props.theme.colors['terra-cotta']};
    color: ${(props) =>
      props.disableRight ? props.theme.colors['dark'] : 'white'};
    &:hover {
      cursor: ${(props) => (props.disableRight ? 'default' : 'pointer')};
    }
  }
`;

const Pagination = ({
  disableLeft,
  disableRight,
  onClickLeft,
  onClickRight,
  children
}) => {
  return (
    <PaginationContainer disableLeft={disableLeft} disableRight={disableRight}>
      <div
        className="arrowContainer arrowLeft"
        onClick={() => (onClickLeft && !disableLeft ? onClickLeft() : null)}
      >
        <Icon icon="arrowFullLeft" />
      </div>
      {children}
      <div
        className="arrowContainer arrowRight"
        onClick={() => (onClickRight && !disableRight ? onClickRight() : null)}
      >
        <Icon icon="arrowFullRight" />
      </div>
    </PaginationContainer>
  );
};

export default Pagination;
